/*
 * Copyright (c) 2026. Tooling Team
 */

export const ROW_STATE_LABELS = {
  added: "Added",
  deleted: "Deleted",
  new: "New",
  updated: "Updated",
};

export const ROW_STATE_BADGE_CLASSES = {
  added: "bg-primary",
  deleted: "bg-secondary",
  new: "bg-primary",
  updated: "bg-optum-orange",
};

export function getMvdRowState(row) {
  const flags = row?.flags;
  const updateHistory = flags?.updateHistory;
  const hasUpdateHistory =
    !!updateHistory &&
    (typeof updateHistory !== "object" ||
      Object.keys(updateHistory).length > 0);

  if (row?.delete || flags?.deleted) {
    return "deleted";
  }

  if (row?.add || flags?.added) {
    return "added";
  }

  if (row?.isNew || flags?.isNew) {
    return "new";
  }

  if (row?.update || hasUpdateHistory) {
    return "updated";
  }

  return "";
}
